<template>
    <div class="row align-items-start pt-2">
        <div v-if="!horizontal" class="card-group col-lg-4 col-md-6 col-sm-12 pt-3" v-for="(post, index) in posts" :key="index">
            <div class="card">
              <router-link v-if="!post.promotion && post.content_type"
                :to="{
                  name: 'BlogSingle',
                  params: { 
                      locale: this.locale,
                      blogId: post.id,
                      blogName: post.slug
                  }
                }"
              >              
                <img class="cursor-pointer" :src="`${post.cover}`" :alt="post.title" width="290" height="164">
              </router-link>    
              <a v-else-if="!post.promotion && !post.content_type" :href="post.link_redirect">
                <img class="cursor-pointer" :src="`${post.cover}`" :alt="post.title" width="290" height="164">
              </a>    
              <img v-else :src="`${post.cover.image}`" alt="Banner" @click="redirectBanner(post.cover.url)" width="290" height="164">
                <div class="card-body pt-1" v-if="!post.promotion">
                  <router-link v-if="post.content_type"
                    :to="{
                      name: 'BlogSingle',
                      params: { 
                          locale: this.locale,
                          blogId: post.id,
                          blogName: post.slug
                      }
                    }"
                  >              
                    <h5 v-if="horizontal" class="card-title">{{ post.title }}</h5>
                    <h5 v-else class="card-title-small">{{ post.title }}</h5>
                  </router-link> 
                  <a v-else :href="post.link_redirect">
                    <h5 v-if="horizontal" class="card-title">{{ post.title }}</h5>
                    <h5 v-else class="card-title-small">{{ post.title }}</h5>
                  </a>    

                    <p class="card-text row c-text" v-for="description in post.meta_description" :key="description.language_id">
                        <span v-if="description.language_id === 1 && locale === 'pt-br'"
                            v-text="description.content"></span>
                        <span v-if="description.language_id === 2 && locale === 'en'" v-text="description.content"></span>
                    </p>

          <div class="row">
            <p class="card-text small col-6" v-if="post.content_type">
              <font-awesome-icon :icon="['far', 'comment-dots']" size="sm" /> {{ post.comments }}
              {{ translateMain.commentsBlog }}
            </p>
            <p class="card-text small col-6">
              <font-awesome-icon :icon="['far', 'clock']" size="sm" /> {{ post.date }}
            </p>
          </div>

          <router-link v-if="post.content_type"
            :to="{
              name: 'BlogSingle',
              params: { 
                  locale: this.locale,
                  blogId: post.id,
                  blogName: post.slug
              }
            }"
            class="button--more"
          >
            {{ translateMain.moreBlog }}
            <font-awesome-icon :icon="['fas', 'arrow-right']" size="sm" style="margin-left: 8px" />
          </router-link>
          <a v-else :href="post.link_redirect" class="button--more"> 
            {{ translateMain.moreBlog }}
            <font-awesome-icon :icon="['fas', 'arrow-right']" size="sm" style="margin-left: 8px" />
          </a>    
        </div>
      </div>
    </div>
    <div v-else class="card-group col-lg-12 col-sm-12 my-3">
      <div class="card">
        <div class="row">
          <div class="col-lg-7">
            <router-link v-if="posts.content_type"
              :to="{
                name: 'BlogSingle',
                params: { 
                    locale: this.locale,
                    blogId: posts.id,
                    blogName: posts.slug
                }
              }"
            >              
              <img class="horizontal cursor-pointer" :src="`${posts.img!=''? posts.img : posts.cover}`" :alt="posts.title" width="602" height="338"/>
            </router-link>   
            <a v-else :href="posts.link_redirect"> 
              <img class="horizontal cursor-pointer" :src="`${posts.img!=''? posts.img : posts.cover}`" :alt="posts.title" width="602" height="338"/>
            </a>    
          </div>
          <div class="card-body ps-4 col-lg-5" v-if="!posts.promotion">
            <router-link v-if="posts.content_type"
              :to="{
                name: 'BlogSingle',
                params: { 
                    locale: this.locale,
                    blogId: posts.id,
                    blogName: posts.slug
                }
              }"
            >              
              <h5 class="card-title">{{ posts.title }}</h5>            
            </router-link>                  
            <a v-else :href="posts.link_redirect"> 
              <h5 class="card-title">{{ posts.title }}</h5>
            </a>    
            <p
              class="card-text row "
              v-for="description in posts.meta_description"
              :key="description.language_id"
            >
              <span
                v-if="description.language_id === 1 && locale === 'pt-br'"
                v-text="description.content"
              ></span>
              <span
                v-if="description.language_id === 2 && locale === 'en'"
                v-text="description.content"
              ></span>
            </p>

            <div class="row">
              <p class="card-text small col-6" v-if="posts.content_type">
                <font-awesome-icon :icon="['far', 'comment-dots']" size="sm" />
                {{ posts.comments }} {{ translateMain.commentsBlog }}
              </p>
              <p class="card-text small col-6">
                <font-awesome-icon :icon="['far', 'clock']" size="sm" /> {{ posts.date }}
              </p>
            </div>

            <router-link v-if="posts.content_type"
              :to="{
                name: 'BlogSingle',
                params: { 
                    locale: this.locale,
                    blogId: posts.id,
                    blogName: posts.slug
                }
              }"
              class="button--more"
            >
              {{ translateMain.moreBlog }}
              <font-awesome-icon
                :icon="['fas', 'arrow-right']"
                size="sm"
                style="margin-left: 8px"
              />
            </router-link>
            <a v-else :href="posts.link_redirect" class="button--more"> 
              {{ translateMain.moreBlog }}
              <font-awesome-icon
                :icon="['fas', 'arrow-right']"
                size="sm"
                style="margin-left: 8px"
              />
            </a>    
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
  import { mapState } from 'pinia'
  import { localeStore } from 'stores/locale'
  import translateMain from 'tradutors/menu'
  import router from '../../router'

  export default {
    name: 'CardsBlog',
    props: ['posts', 'horizontal'],
    computed: {
      ...mapState(localeStore, ['locale']),
      translateMain: function () {
        if (this.locale === 'pt-br') {
          return translateMain.portugues
        } else {
          return translateMain.ingles
        }
      }
    },
    methods: {
      redirectBanner(url){
        window.location.href = url;
      },
      redirect(name, id, slug) {
        router.push({ name , params: { locale: this.locale, blogId: id, blogName: slug } })
      }
    }
  }
</script>
<style scoped>
  .card-title {
    color: #B20000;
    font-family: 'Roboto-Medium';
    font-size: 32px;
    font-weight: 500;
    letter-spacing: 0;
    line-height: 38px;
  }

  .card-title-small {
    color: #B20000;
    font-family: 'Roboto-Medium';
    font-size: 18px;
    font-weight: 500;
    letter-spacing: 0;
    line-height: 21px;    
  }

  .card-text span {
    color: #5b5858;
    font-family: 'Roboto-Regular';
    font-size: 16px;
    letter-spacing: 0;
    line-height: 19px;
    display: block;
  }

  .small {
    color: #5b5858;
    font-family: 'Roboto-Regular';
    font-size: 13px;
    letter-spacing: 0;
    margin-bottom: 0px;
  }  

  .button--more svg {
    color: #b20000;
  }

  .button--more {
    height: 19px;
    color: #666666;
    font-family: "Exo-2";
    font-size: 16px;
    letter-spacing: 0;
    line-height: 19px;
    text-align: right;
  }

  .small svg {
    margin-right: 5px;
  }

  .card img {
    width: 290px;
    height: 164px;
    object-fit: cover;
  }

  .horizontal {
    width: 602px !important;
    height: 338px !important;
  }

  .banner-promotion img {
    width: 391px;
    height: 222px;
    cursor: pointer;
    object-fit: cover;
  }

  .card-body {
    background-color: #fff;
    padding: 0px;
  }

  .category-title {
    background-color: black;
    border-radius: 20px;
    text-align: center;
    max-width: 9rem;
    color: #fff;
    font-size: small;
  }
  .c-text{
    margin-bottom: 5px;
  }

/* regras mobile 769vp */
@media screen and (max-width: 992px) {
    .horizontal {
        width: 100% !important;
        height: unset !important;
    }    
    .card img {
        width: 100%;
        height: unset;
        object-fit: cover;
    }    

    .card-title {
      color: #B20000;
      font-family: 'Roboto-Medium';
      font-size: 24px;
      font-weight: 500;
      letter-spacing: 0;
      line-height: 38px;
    }

    .card-body {
      padding-left: 10px !important;
    }

}
</style>
